<ng-container *ngIf="loading">
    <ngx-skeleton-loader [theme]="{
        width: '100%',
        height: '150px'
      }">
    </ngx-skeleton-loader>

    <app-spacer [bottom]="24"></app-spacer>

    <ngx-skeleton-loader [theme]="{
        width: '100%',
        height: '300px'
      }">
    </ngx-skeleton-loader>
</ng-container>

<ng-container *ngIf="!loading">
    <div class="dash-card no-padding">
        <div class="dash-card-header d-block">
            <h2>{{label}}</h2>
            <app-spacer [bottom]="8"></app-spacer>

            <p>Nesta etapa, selecione o tipo de template de minuta que será
                utilizado.<br> Em seguida, vincule os fundos de investimento aos
                quais este modelo será aplicado.<br>
                Essa configuração garante que, ao gerar minutas para os fundos
                vinculados, o sistema utilize automaticamente o template
                correspondente, de forma padronizada e segura.</p>
        </div>

        <div class="dash-card-body padding-container mb-5"
            style="overflow: visible">
            <div class="col-12" style="padding: 0 30px 20px;">
                <form [formGroup]="form">
                    <div class="row">
                        <div class="col-lg-8">
                            <app-select [items]="modelsOptions" [group]="form"
                                controlName="model" placeholder="Selecione"
                                label="Selecionar template">
                            </app-select>
                        </div>

                        <div class="col-lg-4">
                            <app-select [items]="riskOptions" [group]="form"
                                controlName="risk" placeholder="Selecione"
                                label="Risco">
                            </app-select>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>

    <ng-container *ngIf="form.controls.model.value">
        <div class="dash-card no-padding">
            <div class="dash-card-header d-block">
                <h2>Fundos disponíveis</h2>
            </div>

            <div class="dash-card-body padding-container mb-5">
                <div class="col-12 permission-container"
                    style="padding: 0 30px 20px;">
                    <div class="permission-container-header">
                        <div class="left pt-0" style="border:0;">
                            <h3>Fundos disponíveis</h3>
                            <app-spacer [bottom]="8"></app-spacer>

                            <div class="permission-container-header-search">
                                <svg-icon
                                    src="assets/images/icon-search.svg"></svg-icon>
                                <app-spacer [right]="8"></app-spacer>

                                <app-input [group]="searchForm"
                                    style="width: 100%;"
                                    controlName="avaliablePermissions"
                                    [maxLength]="60">
                                </app-input>

                            </div>
                        </div>
                        <div class="right pt-0" style="border:0;">
                            <h3>Fundos vinculados</h3>
                            <app-spacer [bottom]="8"></app-spacer>

                            <div class="permission-container-header-search">
                                <svg-icon
                                    src="assets/images/icon-search.svg"></svg-icon>
                                <app-spacer [right]="8"></app-spacer>

                                <app-input [group]="searchForm"
                                    style="width: 100%;"
                                    controlName="selectedPermissions"
                                    [maxLength]="60">
                                </app-input>

                            </div>
                        </div>
                    </div>

                    <div class="permission-container-body">
                        <div class="left">
                            <p class="pl-4 d-flex">
                                <ng-container
                                    *ngIf="permissionsAvaliable.length > 0">
                                    <app-radio
                                        (onCheckChanged)="handleCheckAll(true)"
                                        [multiple]="true"
                                        [isChecked]="verifyCheckAll(true)">
                                    </app-radio>
                                </ng-container>
                                {{permissionsAvaliableCheckedNumber}} de
                                {{totalPermissionsAvaliableOptions}} itens
                                selecionados
                            </p>
                            <app-spacer [bottom]="16"></app-spacer>

                            <div class="permission-container-body-list">
                                <div class="permission-container-body-list-item"
                                    *ngFor="let item of permissionsAvaliable; let i = index">
                                    <app-radio
                                        (onCheckChanged)="toggleValue(item,false,true)"
                                        [multiple]="true"
                                        [isChecked]="isOptionsChecked(item,false,true)">
                                        {{item.label}}
                                    </app-radio>
                                </div>
                            </div>
                        </div>
                        <div class="buttons-container">
                            <button [disabled]="getDisabled(false,true)"
                                (click)="changeSide(false,true)">
                                <svg-icon
                                    src="assets/images/icon-right.svg"></svg-icon>
                            </button>

                            <button [disabled]="getDisabled()"
                                (click)="changeSide()">
                                <svg-icon
                                    src="assets/images/icon-left.svg"></svg-icon>
                            </button>
                        </div>
                        <div class="right">
                            <p class="pl-4 d-flex">
                                <ng-container
                                    *ngIf="visiblePermissionsSelected.length > 0">
                                    <app-radio
                                        (onCheckChanged)="handleCheckAll()"
                                        [multiple]="true"
                                        [isChecked]="verifyCheckAll()">
                                    </app-radio>
                                </ng-container>
                                {{permissionsSelectedCheckedNumber}} de
                                {{totalPermissionsSelectedOptions}} itens
                                selecionados
                            </p>
                            <app-spacer [bottom]="16"></app-spacer>

                            <div class="permission-container-body-list">
                                <div class="permission-container-body-list-item"
                                    *ngFor="let item of visiblePermissionsSelected; let i = index">
                                    <app-radio
                                        (onCheckChanged)="toggleValue(item)"
                                        [multiple]="true"
                                        [isChecked]="isOptionsChecked(item)">
                                        {{item.label}}
                                    </app-radio>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="text-right">
            <app-button (onClick)="submit()" [disabled]="getSubmitDisabled()"
                class="add-button" [loading]="sendingRequest">
                Salvar
            </app-button>
        </div>
    </ng-container>
</ng-container>